var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8265 6.5312L8.34764 10.8226C8.19764 10.9492 8.05702 11.0007 7.93748 11.0007C7.81795 11.0007 7.65694 10.9487 7.54866 10.844L3.04866 6.5312C2.82375 6.31792 2.81644 5.94058 3.03178 5.73667C3.24565 5.51108 3.60319 5.50375 3.82655 5.71983L7.93748 9.66011L12.0484 5.72261C12.2711 5.50654 12.6292 5.51387 12.8432 5.73945C13.0586 5.94058 13.0515 6.31792 12.8265 6.5312Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.42ed4c9ec690efc2d728a45f9f83389e.svg";
export { ForwardRef as ReactComponent };